import config from 'config';

export function getGuestMagicLinkParams(search: string) {
    const params = new URLSearchParams(search);
    return {
        token: params.get('token'),
        isGuest: params.get('isGuest') === 'true',
    };
}

export function isGuestMagicLink(pathname: string, search: string): boolean {
    const { token, isGuest } = getGuestMagicLinkParams(search);
    return pathname === config.routes.guestVerify && isGuest && Boolean(token);
}
